"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "ternate": {
    "c777411a": [{
      "hkey": "f049804d",
      "slug": "ternate",
      "name": "Ternate",
      "primary": true,
      "skipSearch": false
    }],
    "roncaccio": [{
      "hkey": "f049804d",
      "slug": "ternate",
      "name": "Ternate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ea5b6b84": [{
      "hkey": "f049804d",
      "slug": "ternate",
      "name": "Ternate",
      "primary": true,
      "skipSearch": false
    }],
    "santa-maria": [{
      "hkey": "f049804d",
      "slug": "ternate",
      "name": "Ternate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;